export const parseBoolean = (value) => {
  if (typeof value === "boolean") return value;
  else if (typeof value === "string" && (value.toLowerCase() === "false" || value === "0")) return false;
  else if (typeof value === "string" && (value.toLowerCase() === "true" || value === "1")) return true;
  else if (typeof value === "number" && value === 0) return false;
  else if (typeof value === "number" && value === 1) return true;
  /// everything else set to false
  return false;
}